import React from 'react'
import LayoutMain from '../../components/Layout/Main/Main'
import GridItemCollection from "../../Partials/GridItem/Collection";
import Section from "../../Partials/Section/index";

import DataProjects from '../../Data/projects'

const Projects = () => {
  return (
    <LayoutMain>
        <section className="title">
             <h1>Projects</h1>
        </section>
        <section className=" mb-100 mt-100">
        <div className="container-2">
        <Section>
          <div className="row">
            <GridItemCollection data={DataProjects} />
          </div>
        </Section>
        </div>
        </section>

   </LayoutMain>
  )
}

export default Projects
